<template>
    <div class="fixed right-0 top-96 z-10">
        <div class="border rounded-tl-lg bg-white w-[84px]">
            <div class="h-[90px] w-full border-b flex flex-col items-center justify-center cursor-pointer"
                @click="goTop" @mouseenter="is_top = true" @mouseleave="is_top = false">
                <img src="../../static/image/icon/top.png" alt="" :class="{'translate-y-[-5px]':is_top}"
                    class="w-6 h-6 mb-2 duration-300">
                <div class="text-sm text-666" :class="{ 'text-[#c09765]': is_top }">
                    {{ $t('回到顶部') }}
                </div>
            </div>
            <div class="h-[90px] w-full flex flex-col items-center justify-center cursor-pointer"
                :class="{'border-b':routeName=='diwaStore'||routeName=='textbookPurchase'}" @click="onGoCart"
                @mouseenter="is_car = true" @mouseleave="is_car = false">
                <img src="../../static/image/icon/cart.png" alt="" class="w-6 h-6 mb-2 duration-300"
                    :class="{ 'scale-[1.2]': is_car }">
                <div class="text-sm text-666" :class="{ 'text-[#c09765]': is_car }">
                    {{ $t('购物车') }}
                </div>
            </div>
            <div class="h-[90px] w-full flex flex-col items-center justify-center cursor-pointer"
                v-if="routeName=='diwaStore'||routeName=='textbookPurchase'" @click="onMyCollect"
                @mouseenter="is_collect = true" @mouseleave="is_collect = false">
                <img src="../../static/image/icon/collect.png" alt="" :class="{ 'scale-x-[-1]': is_collect }"
                    class="w-6 h-6 mb-2 duration-300">
                <div class="text-sm text-666" :class="{ 'text-[#c09765]': is_collect }">
                    {{ $t('我的收藏') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                is_top: false,
                is_car: false,
                is_collect: false,
            }
        },
        props: {
            routeName: {
                type: String,
                default: '',
            }
        },
        methods: {
            /**去收藏*/
            onMyCollect() {
                this.$router.push({ path: '/myCollect' });
            },
            /**去购物车*/
            onGoCart() {
                this.$router.push({ path: '/shoppingCart' });
            },
            /** 回到顶部 - 支持平滑滚动 + 兼容性处理 */
            goTop() {
                // 方式1：现代浏览器原生平滑滚动（推荐）
                if (window.scrollTo) {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth' // 平滑滚动
                    });
                } else {
                    // 方式2：兼容低版本浏览器（无平滑效果）
                    document.documentElement.scrollTop = 0;
                    document.body.scrollTop = 0;
                }

                // 可选：如果是Vue Router单页应用，且需要重置路由滚动位置
                // this.$router.push({ path: this.$route.path, query: this.$route.query }, () => {
                //     window.scrollTo(0, 0);
                // });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
